// Native details keeps the account links usable before scripts load.
document.querySelectorAll('[data-account-menu]').forEach((menu) => {
    const toggle = menu.querySelector('summary');
    const close = () => { menu.open = false; };

    toggle.addEventListener('click', () => {
        if (!menu.open) {
            const search = document.querySelector('.site-header__search-button.is-active');
            if (search) search.click();
        }
    });

    document.addEventListener('click', (event) => {
        if (!menu.contains(event.target)) close();
    });
    document.addEventListener('focusin', (event) => {
        if (!menu.contains(event.target)) close();
    });
    menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && menu.open) {
            event.preventDefault();
            close();
            toggle.focus();
        }
    });
    window.matchMedia('(min-width: 980px)').addEventListener('change', close);
});
